var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.831 5.02335C27.7609 4.0935 28.2258 3.62859 28.7408 3.40626C29.4829 3.08593 30.3242 3.08593 31.0663 3.40626C31.5812 3.62859 32.0462 4.0935 32.9759 5.02335C33.9058 5.95319 34.3708 6.41811 34.5931 6.93317C34.9135 7.67519 34.9135 8.51648 34.5931 9.25851C34.3708 9.77357 33.9058 10.2385 32.9759 11.1683L25.0252 19.1192C23.0663 21.0781 22.0869 22.0576 20.8601 22.6379C19.6333 23.2181 18.2549 23.3542 15.498 23.6262L14.25 23.7494L14.3732 22.5014C14.6452 19.7445 14.7812 18.366 15.3615 17.1393C15.9418 15.9125 16.9212 14.9331 18.8801 12.9742L26.831 5.02335Z",
    stroke: "#2D3036",
    strokeWidth: 2.375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 23.75H5.93752C4.40723 23.75 3.16669 24.9905 3.16669 26.5208C3.16669 28.0511 4.40723 29.2917 5.93752 29.2917H20.9792C22.5095 29.2917 23.75 30.5322 23.75 32.0625C23.75 33.5928 22.5095 34.8333 20.9792 34.8333H17.4167",
    stroke: "#2D3036",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/editBlack.836ebc140a00b884bd052d9726653c5c.svg";
export { ForwardRef as ReactComponent };